import { Injectable } from '@angular/core';
import { Observable, Subscription, interval } from 'rxjs';
import { RxStomp } from '@stomp/rx-stomp';
import SockJS from 'sockjs-client';
import { HttpService } from './http.service';
import { Logger } from './logger.service';
import { AuthService } from '../auth/auth.service';
import { NotificationService } from './notification.service';
import { AppConstants, JsonHelper } from '../util/index';
import { EventNotification, User, ResponseJson } from '../models/index';

@Injectable()
export class EventService {
  private subscription: Subscription;
  private subscription2: Subscription;
  private lastQueryTime = '';
  public pullUserEventUpdate: Subscription;
  private userEvents: Array<EventNotification> = [];

  constructor(private httpService: HttpService, private rxStomp: RxStomp, private log: Logger, private notifService: NotificationService) {
    rxStomp.configure({
      webSocketFactory: () => new SockJS(AppConstants.WebSocketEndPoint),
      debug: () => {}
    });
  }

  pullUserEvents() {
      this.pullUserEventUpdate = interval(10000).subscribe(() => {
        this.queryUserEvents();
    });
  }

  private queryUserEvents() {
    this.httpService.get(AppConstants.QueryUserEventsURL + '?lastQueryTime=' + this.lastQueryTime, [this.postQueryEventsHandler]);
  }

  private postQueryEventsHandler = (responseJson: ResponseJson) => {
    if (responseJson.status === AppConstants.SUCCESS) {
      this.lastQueryTime = responseJson.message;
      this.userEvents = JsonHelper.parseArray(responseJson.data, EventNotification);

      this.userEvents.forEach(event => {
        if (event.eventType === 'RefreshData') {
          return;
        }

        if (event.severity > 2) {
          this.notifService.addSticky({ severity: 'info', summary: '', detail: event.message });
        } else {
          this.notifService.add({ severity: 'info', summary: '', detail: event.message });
        }
        this.log.debug(JsonHelper.toJson(event));
      });
    }
  }

  connect(loginUser: User) {
    this.rxStomp.activate();
    this.subscription = this.rxStomp.watch('/topic/partitionEvent.' + loginUser.customerId)
      .subscribe((message) => this.response(message.body));
    // this.subscription2 = this.rxStomp.watch('/topic/dataSetUpdateEvent').subscribe((message) => this.dataSetEventResponse(message.body));
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      if (this.subscription2) {
        this.subscription2.unsubscribe();
      }
      this.rxStomp.deactivate().then(() => {
        this.log.debug('socket connection closed');
      });
    }
  }

  response = (data) => {
    const event = JsonHelper.parse(data, EventNotification);

    if (event.severity > 2) {
      this.notifService.addSticky({ severity: 'info', summary: '', detail: event.message });
    } else {
      this.notifService.add({ severity: 'info', summary: '', detail: event.message });
    }
    this.log.debug(JsonHelper.toJson(event));
  }

  dataSetEventResponse = (data) => {
    const event = JsonHelper.parse(data, EventNotification);
    this.log.debug(JsonHelper.toJson(event));
    this.log.debug('last data set refresh time: ' + event.createTimestamp);
  }
}




